

export const ProductsList = [
    {
        name:'Plural Gateway',
        label: 'Plural Gateway is a secure, user-friendly payment gateway designed to give you exactly what you need to sell online.',
        iconURL: 'product-plural-gateway',
        active: false,
    },
    {
        name:'Plural Tokenizer',
        label: 'Plural Gateway is a secure, user-friendly payment gateway designed to give you exactly what you need to sell online.',
        iconURL: 'product-plural-tokenizer',
        active: false,
    }
];
